import React, { useEffect } from "react";
import {
  Box,
  Button,
  ClickAwayListener,
  Paper,
  MenuList,
  MenuItem,
  Popper,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Colors } from "../../utils/constants";
import { updateAbdcGrade } from "../../store/slice/browseFilterSlice";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../store/hooks";
const data = [
  { label: "All", value: "" },
  { label: "A*", value: "100" },
  { label: "A", value: "90" },
  { label: "B", value: "80" },
  { label: "C", value: "70" },
  // { label: "D", value: "60" },
];

interface ABDCGradeItem {
  label: string;
  value: string;
}

interface ABDCGradeDropdownProps {
  handleABDCGrade: (grade: ABDCGradeItem) => void;
  from?: string;
}

// const ABDCGradeDropdown = () => {
const ABDCGradeDropdown: React.FC<ABDCGradeDropdownProps> = ({
  handleABDCGrade,
  from,
}) => {
  const basicSearchabdcGrade: string = useAppSelector(
    (state) => state.filterReducer?.abdcGrade
  );

  const journalFinderabdcGrade: string = useAppSelector(
    (state) => state.browseFilterSlice.abdcGrade
  );

  let initialItem;

  if (from === "basicSearch") {
    initialItem = data.find((d) => d.value === basicSearchabdcGrade) || data[0];
  } else if (from === "journalFinder") {
    initialItem =
      data.find((d) => d.value === journalFinderabdcGrade) || data[0];
  } else {
    initialItem = data[0];
  }

  //const initialItem = data.find((d) => d.value === abdcGrade) || data[0];
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState(false);
  //const [selectedItem, setSelectedItem] = React.useState(data[0]);
  const [selectedItem, setSelectedItem] =
    React.useState<ABDCGradeItem>(initialItem);
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(updateAbdcGrade(selectedItem.value));
    handleABDCGrade(selectedItem);
  }, [selectedItem]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen((prev) => !prev);
  };

  const handleSelect = (item: { label: string; value: string }) => {
    setSelectedItem(item);
    setOpen(false);
  };

  const handleClickAway = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <Button
        style={{
          textAlign: "left",
          color: Colors.black,
          paddingTop: 0,
          paddingBottom: 0,
        }}
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant="outlined"
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        <Button
          sx={{
            // fontSize: "0.8rem",
            color: Colors.black,
            // minHeight: 0,
            // padding: "5px 5px",

            fontFamily: "Helvetica Neue",
            fontStyle: "normal",
            fontWeight: 400,
            // fontSize: { xs: 12, sm: 14, md: 14 },
            fontSize: "o.8rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          ABDC Ratings {selectedItem.label}
        </Button>
      </Button>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        modifiers={[
          {
            name: "offset",
            options: {
              offset: [0, 4],
            },
          },
          {
            name: "preventOverflow",
            options: {
              boundary: "viewport",
            },
          },
        ]}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Paper sx={{ maxHeight: 300, overflowY: "auto" }}>
            <MenuList>
              {data.map((item) => (
                <MenuItem
                  key={item.value}
                  selected={item.value === selectedItem.value}
                  onClick={() => handleSelect(item)}
                >
                  {item.label}
                </MenuItem>
              ))}
            </MenuList>
          </Paper>
        </ClickAwayListener>
      </Popper>
    </Box>
  );
};

export default ABDCGradeDropdown;
